module.exports = __webpack_public_path__ + "static/media/tada.7e9e3f29.png";